import React from 'react';
import { useFormikContext } from 'formik';
import { Panel, PanelHeader, PanelBody } from '../../../../components/panel/panel';

// Componente para mensajes de alerta de los subtotales de las facturas
function ResumeInvoiceCoverage({ contadoSinIva, creditoSinIva}) {
    const { values } = useFormikContext();

    const creditoTotalInvoice = Number(creditoSinIva || 0);
    const contadoTotalInvoice = Number(contadoSinIva || 0);

    const penalizacionFinal = Number(values.servicio_muerto_monto_penalizacion); 
    //console.log("penalizacion:", penalizacionFinal);
   
    const subtotal = penalizacionFinal !== 0 && penalizacionFinal !== null
    ? Number(penalizacionFinal)
    : Number(values.subtotal || 0);

    const usePenalizacion = penalizacionFinal !== 0 && penalizacionFinal !== null;

    function formatNumberWithCommas(number) {
        if (number || number === 0) {
            const roundedNumber = parseFloat(number).toFixed(2);
            return roundedNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return '';
    }

    const tolerance = 1.00; 
    const totalFacturado = creditoTotalInvoice + contadoTotalInvoice;

    const cubreSubtotal = Math.abs(totalFacturado - subtotal) <= tolerance;
    const excedeSubtotal = totalFacturado > subtotal + tolerance;
    const faltaSubtotal = totalFacturado < subtotal - tolerance;
    
    let alertType = 'success';
    let iconClass = 'fa-face-smile';
    let mensaje = usePenalizacion
        ? '✅ La penalización está completamente cubierta por las facturas emitidas.'
        : '✅ La orden está completamente cubierta por las facturas emitidas.';

    if (faltaSubtotal) {
        alertType = 'warning';
        iconClass = 'fa-face-frown';
        mensaje = usePenalizacion
            ? <>⚠️ La penalización <strong>NO está completamente cubierta</strong>. Falta por facturar: <strong>${formatNumberWithCommas(subtotal - totalFacturado)}</strong></>
            : <>⚠️ La orden <strong>NO está completamente cubierta</strong>. Falta por facturar: <strong>${formatNumberWithCommas(subtotal - totalFacturado)}</strong></>;
    } else if (excedeSubtotal) {
        alertType = 'danger';
        iconClass = 'fa-face-surprise';
        mensaje = usePenalizacion
        ? <>❗ El total facturado <strong>excede</strong> el monto de penalización por: <strong>${formatNumberWithCommas(totalFacturado - subtotal)}</strong></>
        : <>❗ El subtotal facturado <strong>excede</strong> el subtotal de la orden por: <strong>${formatNumberWithCommas(totalFacturado - subtotal)}</strong></>;
    }

    return (
    <>
    <PanelHeader noButton={true}>
                {usePenalizacion ? 'Penalización por cancelación' : 'Resumen de subtotales'}
    </PanelHeader>

        <div className={`note alert-${alertType} mb-2`}>
            <div className="note-icon">
                <i className={`fa ${iconClass}`}></i>
            </div>
            <div className="note-content">
                {/* <h5><b>Resumen de subtotal Facturación</b></h5> */}
                <p>
                        {usePenalizacion
                            ? 'Monto de penalización:'
                            : 'Subtotal de la orden:'}
                        <strong> ${formatNumberWithCommas(subtotal)}</strong><br />
                        {usePenalizacion
                            ? 'Facturación al contado aplicada a penalización:'
                            : 'Subtotales facturado al contado:'}
                        <strong> ${formatNumberWithCommas(contadoTotalInvoice)}</strong><br />
                        {usePenalizacion
                            ? 'Facturación a crédito aplicada a penalización:'
                            : 'Subtotales facturados a crédito:'}
                        <strong> ${formatNumberWithCommas(creditoTotalInvoice)}</strong><br />
                        <br />
                        {mensaje}
                    </p>
            </div>
        </div>
    </>
    );
}

export default ResumeInvoiceCoverage;
